import React from 'react'
import styled from '@emotion/styled'

const Container = ({ children }) => {
  return <ContainerStyle>{children}</ContainerStyle>
}

const ContainerStyle = styled.div`
  z-index: 0;
  position: relative;
  overflow: hidden;
`
export default Container
